export const MessageTypes = {
  sms: 'sms',
  chat: 'chat',
} as const;

export type MessageType = (typeof MessageTypes)[keyof typeof MessageTypes];
